import { RegistrationCoverageCheckScreen } from "@/interactors/RegistrationCoverageCheckScreen";

export default function CheckCoverage() {
  return <RegistrationCoverageCheckScreen />;
}
